import { render, staticRenderFns } from "./AgencyClients.vue?vue&type=template&id=0765700c&scoped=true&"
import script from "./AgencyClients.vue?vue&type=script&setup=true&lang=js&"
export * from "./AgencyClients.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765700c",
  null
  
)

export default component.exports